import { render, staticRenderFns } from "./Mountain.vue?vue&type=template&id=6c3361ba&"
import script from "./Mountain.vue?vue&type=script&lang=js&"
export * from "./Mountain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports